import { h, Host } from "@stencil/core";
export class GxgScroll {
    render() {
        return (h(Host, { class: "gxg-scrollbar" }, h("slot", null)));
    }
    static get is() { return "gxg-scroll"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["scroll.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["scroll.css"]
        };
    }
}
//# sourceMappingURL=scroll.js.map
